// **Persona Giuridica - Cliente Fields**
export const portantePersonaGiuridicaClienteFields = [
  {
    name: "ragioneSociale",
    label: "Ragione sociale",
    type: "text",
    required: true,
  },
  { name: "piva", label: "PIVA", type: "text", required: true },
  {
    name: "slResProvincia",
    label: "Provincia",
    type: "select",
    required: true,
  },
  {
    name: "slResComuneCodice",
    label: "Comune",
    type: "select",
    required: true,
  },
  { name: "slResCap", label: "CAP", type: "select", required: true },
  {
    name: "slResIndirizzoVia",
    label: "Via",
    type: "select",
    optionsKey: "Via",
    required: true,
  },
  {
    name: "slResIndirizzo",
    label: "Indirizzo",
    type: "text",
    required: true,
  },
  { name: "slResCivico", label: "Civico", type: "text", required: true },
];

// **Persona Fisica - Cliente Fields**
export const portantePersonaFisicaClienteFields = [
  { name: "cognome", label: "Cognome", type: "text", required: true },
  { name: "nome", label: "Nome", type: "text", required: true },
  { name: "cf", label: "Codice fiscale", type: "text", required: true },
  {
    name: "slResProvincia",
    label: "Provincia",
    type: "select",
    required: true,
  },
  {
    name: "slResComuneCodice",
    label: "Comune",
    type: "select",
    required: true,
  },
  { name: "slResCap", label: "CAP", type: "select", required: true },
  {
    name: "slResIndirizzoVia",
    label: "Via",
    type: "select",
    optionsKey: "Via",
    required: true,
  },
  {
    name: "slResIndirizzo",
    label: "Indirizzo",
    type: "text",
    required: true,
  },
  { name: "slResCivico", label: "Civico", type: "text", required: true },
];

// **Veicolo fields**
export const portanteVeicoloFields = [
  { name: "targa", label: "Targa", type: "text", required: true },
  {
    name: "tipoVeicolo",
    label: "Tipo Veicolo",
    type: "select",
    required: true,
  },
  { name: "uso", label: "Uso", type: "select", required: true },
  { name: "marca", label: "Marca", type: "text", required: true },
  { name: "modello", label: "Modello", type: "text", required: true },
  {
    name: "allestimento",
    label: "Allestimento",
    type: "text",
    required: false,
  },
  {
    name: "Data_Immatricolazione",
    label: "Data Immatricolazione",
    type: "date",
    required: true,
  },
  {
    name: "dataAcquisto",
    label: "Data Acquisto",
    type: "date",
    required: true,
  },
  {
    name: "alimentazione",
    label: "Alimentazione",
    type: "select",
    required: true,
  },
  {
    name: "assicurazioneProvenienza",
    label: "Assicurazione Provenienza",
    type: "text",
    required: true,
  },
  {
    name: "classeMerito",
    label: "Classe Merito",
    type: "text",
    required: true,
  },
  { name: "tariffa", label: "Tariffa", type: "select", required: true },
  {
    name: "dataInizioCopertura",
    label: "Inizio Copertura",
    type: "date",
    required: true,
  },
  {
    name: "dataFineCopertura",
    label: "Fine Copertura",
    type: "date",
    required: true,
  },
  { name: "dataMora", label: "Data Mora", type: "date", required: true },
];
